"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.backofficeServicetokens_de_de = void 0;
function backofficeServicetokens_de_de() {
    return {
        "backoffice.servicetokens.subtitle": "Servicetoken erlauben authorisierte Anfragen an Schnittstellen des Backoffices.",
        "backoffice.servicetokens.permissions": "Berechtigungen",
        "backoffice.servicetokens.create": "Erstelle Servicetoken",
        "backoffice.servicetokens.edit": "Servicetoken bearbeiten",
        "backoffice.servicetokens.changelabel": "Label anpassen",
        "backoffice.servicetokens.addpermissions": "Berechtigungen hinzufügen",
        "backoffice.servicetokens.deletemessage": "Möchten Sie diesen Token wirklich löschen?",
        "backoffice.servicetokens.hitreturn": "Berechtigung mit Eingabetaste bestätigen",
        "backoffice.servicetokens.errors.notfound": "Servicetoken konnte nicht gefunden werden",
        "backoffice.servicetokens.errors.noid": "Es wurde keine Servicetoken ID erhalten.",
        "backoffice.servicetokens.errors.cantchange": "Servicetoken können nicht verändert werden!"
    };
}
exports.backofficeServicetokens_de_de = backofficeServicetokens_de_de;
